import SMSIconSVG from '€icons/SMS';
import EditIconSVG from '€icons/Edit';
import WaitingIconSVG from '€icons/Waiting';
import RenewIconSVG from '€icons/Renew';
import PoundIconSVG from '€icons/Pound';
import CircleCheckIconSVG from '€icons/CircleCheck';
import CircleCancelledIconSVG from '€icons/CircleCancelled';

export const APPLICATION_EXPIRY_DAYS = 14;

export const stageGroups = {
    consultation: 'Consultation with advisor',
    awaitingCustomer: 'Awaiting client documents',
    processing: 'Processing the application',
    underwriting: 'With product provider',
    offer: 'Offer with customer',
    hold: 'On hold',
    completed: 'Complete',
    cancelled: 'Cancelled',
};

export const stageIcons = {
    consultation: SMSIconSVG,
    awaitingCustomer: EditIconSVG,
    processing: RenewIconSVG,
    underwriting: WaitingIconSVG,
    offer: PoundIconSVG,
    completed: CircleCheckIconSVG,
    cancelled: CircleCancelledIconSVG,
};
